import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const Commercial = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Commercial & Contractual laws here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>Welcome to <span className="kwa">KWA</span>, a premier legal establishment specializing in <span className="highlight">commercial and contractual laws</span> in accordance with <span className="highlight">Indian legislation</span>. With a steadfast commitment to excellence and a proven track record of success, our firm stands as a beacon of reliability and proficiency in navigating the intricate landscape of <span className="highlight">commercial and contractual matters</span>.</p>
        <br />
        <p>Our team of seasoned attorneys possesses a deep understanding of the nuanced complexities inherent in <span className="highlight">commercial transactions</span> and <span className="highlight">contractual obligations</span>. Leveraging their extensive expertise and keen insight into Indian laws, they offer strategic counsel and tailored solutions to clients across diverse industries.</p>
        <br />
        <p>At <span className="kwa">KWA</span>, we pride ourselves on delivering comprehensive legal services that encompass the full spectrum of <span className="highlight">commercial and contractual issues</span>. Whether it involves <span className="highlight">drafting</span>, <span className="highlight">negotiating</span>, or <span className="highlight">litigating contracts</span>, <span className="highlight">resolving disputes</span>, or <span className="highlight">providing compliance guidance</span>, our attorneys are equipped with the knowledge and experience to address the multifaceted needs of our clientele.</p>
        <br />
        <p>Moreover, our firm is renowned for its proactive approach to legal representation, wherein we prioritize the preservation of our clients' interests and the attainment of favourable outcomes. With a steadfast dedication to professionalism, integrity, and client satisfaction, we strive to exceed expectations and uphold the highest standards of legal excellence in every matter we undertake.</p>
        <br />
        <p>Entrust your <span className="highlight">commercial and contractual</span> legal needs to <span className="kwa">KWA</span>, where expertise meets unwavering dedication to achieving success for our clients.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default Commercial
